// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Canada from '../_raw/flag/icon_flag_canada.png';

export default () => <img src={Canada} alt="Canada" />;
